import { Navigate, Outlet } from "react-router-dom";

/**
 * Requires a forgot-password email in localStorage before allowing /verify-otp.
 */
export default function VerifyOtpRoute() {
  const forgotEmail = localStorage.getItem("forgotEmail")?.trim();

  if (!forgotEmail) {
    return <Navigate to="/forgot-password" replace />;
  }

  return <Outlet />;
}
